import React, { useEffect, useState } from "react"
import { TextArea, TextBox} from 'devextreme-react';
import SelectBox from "../../../../common/CustomSelectBox"
import { useDispatch, useSelector } from "react-redux";
import { deleteStrangeCharacters } from "../../../../../commonFunctions/commonFunctions";
import { getTaxonomyTemplates } from "../../../../../redux/factoryProcessTemplates/thunks";
import { selectTaxonomyTemplates, selectTaxonomyTemplatesLoading } from "../../../../../redux/factoryProcessTemplates/selectors";
import { FuelCardTypes } from "../../../../../Constantes/FuelCardTypes";

function FuelCardForm(props){
const {classes, onChange, dataForm, template} = props;
const dispatch = useDispatch();
const types = useSelector(selectTaxonomyTemplates);
const [type, setType] = useState(dataForm?.templateCode);
const typesLoading = useSelector(selectTaxonomyTemplatesLoading)


useEffect(()=>{
    dispatch(getTaxonomyTemplates({query: "?templateCode=" + template?.code}))
},[])

useEffect(()=>{
    if(type && types.length > 0){
        onChange("templateId", getTemplateIdFromCode(type))
    }
},[type, types])


function setPhoneNumber(e){
    let nonDigitsRegExp = /\D/gm;
    const filteredNumber = e.value.replace(nonDigitsRegExp, "")
    onChange("phoneNumber", filteredNumber)
}

function setNotes(e){
    const filteredText = deleteStrangeCharacters(e.value); 
    onChange("notes", filteredText)
   
}

function getTemplateIdFromCode(code){
    const result = types.find(type=> type.code === code)
    if(result){
        return result.id
    }
}

    return(
        <div className={classes.containers} id="documentation-request-form">
                    <SelectBox label={"Tipología"} disabled={typesLoading === "loading"} value={type} onValueChanged={(e) => {setType(e.value); onChange("templateCode", e.value)}} valueExpr={"code"} displayExpr="name" placeholder="" dataSource={types} ></SelectBox>
                    <div className="grid-two-columns">
                        <TextBox label={"Nome"} labelMode="floating" key={"name"} name="name" value={dataForm?.name} onValueChanged={(e) => onChange("name",e.value)} className={classes.controlers} ></TextBox>
                        <TextBox label={"Apellidos"} key={"surname"} labelMode="floating" name="surname" value={dataForm?.surname} onValueChanged={(e) => onChange("surname",e.value)} className={classes.controlers} ></TextBox>
                    </div>
                    <div className="grid-three-columns">
                        <TextBox label={"DNI"} key={"dni"} labelMode="floating" name="dni" value={dataForm?.dni} onValueChanged={(e) => onChange("dni",e.value)} className={classes.controlers} ></TextBox>
                        <TextBox label={"Móvil"} key={"phoneNumber"} labelMode="floating" maxLength={9} name="phoneNumber" value={dataForm?.phoneNumber} onValueChanged={(e) =>{setPhoneNumber(e)}} className={classes.controlers} ></TextBox>
                        <TextBox label={"Correo electrónico"} key={"email"} labelMode="floating" name="email" value={dataForm?.email} onValueChanged={(e) => onChange("email",e.value)} className={classes.controlers} ></TextBox> 
                    </div>
                {type === FuelCardTypes.DUPLICATE &&
                    <TextBox label={"Dirección"} key={"address"} labelMode="floating" name="address" value={dataForm?.address} onValueChanged={(e) => onChange("address",e.value)} className={classes.controlers} ></TextBox>}
                    <TextArea label={"Notas"} key={"notes"} labelMode="floating" name="notes" value={dataForm?.notes} onValueChanged={(e) => setNotes(e)} className={classes.controlers} height={60}></TextArea>
        </div>
    )
}

export { FuelCardForm }